import React from 'react';

const ShelfUpdateIcon = ({ width = 80, height = 80, color = "#FFD60A", ...props }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 80 80" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Background circle */}
      <circle cx="40" cy="40" r="38" fill={color} opacity="0.2"/>
      
      {/* Shelf base */}
      <rect x="15" y="48" width="50" height="4" rx="2" fill={color}/>
      <rect x="18" y="52" width="44" height="2" rx="1" fill={color} opacity="0.6"/>
      
      {/* Refresh/Sync arrows */}
      <path 
        d="M 30 25 Q 25 20 25 30 L 28 27 M 50 25 Q 55 20 55 30 L 52 27" 
        stroke={color} 
        strokeWidth="3" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Circular refresh arrow */}
      <path 
        d="M 40 18 
           A 15 15 0 1 1 25 33
           M 25 33 L 22 30 M 25 33 L 28 30"
        stroke={color}
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      <path 
        d="M 40 18 
           A 15 15 0 1 0 55 33
           M 55 33 L 58 30 M 55 33 L 52 30"
        stroke={color}
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      
      {/* Center dot */}
      <circle cx="40" cy="33" r="3" fill={color}/>
    </svg>
  );
};

export default ShelfUpdateIcon;
